import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IAuthLinkRubikaUserQuery } from '@/Module/Auth/Model/ApiModel';
import type { IAuthCheckRubikaTokenResult } from '@/Module/Auth/Model/ApiModel/IAuthCheckRubikaTokenResult';
import { AuthService } from '@/Module/Auth/Service';

export const authLinkRubikaUserAction = createAsyncThunk<IAuthCheckRubikaTokenResult, IAuthLinkRubikaUserQuery>(
  'auth/linkRubikaUser',
  async (req, { signal, rejectWithValue }) => {
    const securityToken: string = 'gBi1KehXGpZgFE3sqWGDQ0XJVBOrmoY9FxGXZkoZVVvPyY80KMRyUYKRW5EY2dH9';
    return AuthService.linkRubikaUser(securityToken, req, { disabledAutoError: true }, signal)
      .then(({ data: { data } }) => data)
      .catch(rejectWithValue);
  },
);
